import { render, staticRenderFns } from "./PaymentCode.vue?vue&type=template&id=528b6382&scoped=true&"
import script from "./PaymentCode.vue?vue&type=script&lang=js&"
export * from "./PaymentCode.vue?vue&type=script&lang=js&"
import style0 from "./PaymentCode.vue?vue&type=style&index=0&id=528b6382&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528b6382",
  null
  
)

export default component.exports